import { render, staticRenderFns } from "./switch-company-modal.vue?vue&type=template&id=0b05cc98&scoped=true&"
import script from "./switch-company-modal.vue?vue&type=script&lang=js&"
export * from "./switch-company-modal.vue?vue&type=script&lang=js&"
import style0 from "./switch-company-modal.vue?vue&type=style&index=0&id=0b05cc98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b05cc98",
  null
  
)

export default component.exports